module.exports = __webpack_public_path__ + "images/precise-measures-124f8986f7ef733685b845743d673672.jpg";